import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import { DFPManager } from 'react-dfp';
import exact from 'prop-types-exact';
import { optionalCookiesAllowed } from '../../../helpers/optionalCookies';
import ArtistTopSongs from '../containers/ArtistTopSongsContainer';
import HeaderTags from '../../../common/headerTags/HeaderTags';
// import Banner from '../../../common/Banner/Banner';
import ErrorPage from '../../../common/errorPage/ErrorPage';
import { transformHTML } from '../../../helpers/transformHTML';
// import InteractiveContainer from '../../../common/interactiveContainer/InteractiveContainer';

// images paths
const A1MEDIA_FACEBOOK = 'https://a1media.antena1.com.br/image/artista/1200x630/';
const A1MEDIA_LARGE = 'https://a1media.antena1.com.br/image/artista/1024x536/';
const A1MEDIA_SMALL = 'https://a1media.antena1.com.br/image/artista/752x392/';
const A1MEDIA_EXTRA_SMALL = 'https://a1media.antena1.com.br/image/artista/560x292/';

// Banners
// const firstRectangleBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'banner',
//     adUnit: 'a1nova-singleArtist-first_rectangle-300x250',
//     sizes: [[300, 250]],
//     shouldRefresh: true,
// };
// const firstLeaderboardBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-12',
//     adUnit: 'a1nova-singleArtist-first_leaderboard-multi_sizes',
//     sizes: [[468, 60], [320, 50], [234, 60]],
//     sizeMapping: [
//         { viewport: [550, 0], sizes: [[468, 60], [320, 50], [234, 60]] },
//         { viewport: [0, 0], sizes: [[320, 50], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

const ArtistSingle = ({ slug, dataArtistSingle, notFound, breakpoint, getSingleArtistIfNeeded, setNotFound }) => {
    const [firstRender, setFirstRender] = useState(true);
    const [isMounted, setIsMounted] = useState(false);
    const responsiveBreakpoints = isMounted ? breakpoint : breakpoint.serverBreakPoints;
    const isResponsive = (name) => responsiveBreakpoints && responsiveBreakpoints[name];

    const _innerHTMLBiographyArtist = () => {
        /**
         * WORK IN Biography artist
         * 1: Change width
         * and height
         * to youtube iframe (when exists) in breakpoint less than large
        * */

        if (dataArtistSingle) {
            let biographyArtist = null;

            // check if artist have biography
            if (dataArtistSingle.biography) {
                biographyArtist = dataArtistSingle.biography;

                const iframe = biographyArtist.includes('</iframe>');

                if (iframe && (isResponsive('isMedium') || isResponsive('isSmall') || isResponsive('isExtraSmall'))) {
                    let height = '';

                    // define height
                    isResponsive('isMedium') ? height = '360px' : isResponsive('isSmall') ? height = '270px' : height = '170px';

                    // add new width and height
                    biographyArtist = biographyArtist.replace('<iframe', `<iframe width="100%" height="${height}"`);
                }
            } else {
                biographyArtist = `${dataArtistSingle.artistName} ainda não possui biografia.`;
            }

            // return { __html: biographyArtist };
            return transformHTML(biographyArtist, `Imagem de conteúdo do artista ${dataArtistSingle.artistName}`);
        }

        return false;
    }


    useEffect(() => {
        if (!firstRender) {
            // Refresh  DFP Banners of page, if the user is checking out several artists one after the other
            if (optionalCookiesAllowed()) DFPManager.refresh();
        }

        // get single artist
        getSingleArtistIfNeeded(slug);

        // go to to
        animateScrollTo(0, { speed: 700 });

        // No need to watch for firstRender, as it is only used to prevent the DFP refresh on the first render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getSingleArtistIfNeeded, slug]);

    useEffect(() => {
        setFirstRender(false);
        setIsMounted(true);

        return () => {
            setNotFound(false); // unset 404 status when leaving
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

    if (notFound) {
        return <ErrorPage
            errorNumber={404}
            backLink="/artistas"
            title="NÃO ACHAMOS ESSE ARTISTA :("
            message="Verifique se o link foi digitado corretamente."
            buttonText="Clique aqui para ver todos os artistas"
        />;
    }

    let coverImageSrc;
    let coverImageSrcSet;
    let coverImageSizes;

    if (dataArtistSingle.imageNew) {
        const encoded = encodeURI(dataArtistSingle.imageNew);
        coverImageSrc = `${A1MEDIA_LARGE}${encoded}`;
        coverImageSrcSet = `${A1MEDIA_EXTRA_SMALL}${encoded} 560w, ${A1MEDIA_SMALL}${encoded} 752w, ${A1MEDIA_LARGE}${encoded} 1024w`;
        coverImageSizes = '(max-width: 575px) 560px, (max-width: 767px) 752px, 1024px';
    } else if (dataArtistSingle.imageOld) {
        coverImageSrc = `https://a1media.antena1.com.br/image/artista/${dataArtistSingle.imageOld}`;
    } else {
        coverImageSrc = `${A1MEDIA_LARGE}defaultArtista.jpg`;
    }

    // Tags meta
    const headerTags = {
        title: `${dataArtistSingle.artistName} - Biografia e discografia`, // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
        meta: {
            description: `Conheça a história de ${dataArtistSingle.artistName}, sua discografia e todas as notícias, curiosidades, imagens e letras das músicas.`,
            keywords: `${dataArtistSingle.artistName}, biografia, discografia`,
            'og:title': `${dataArtistSingle.artistName} - Biografia e discografia`,
            'og:description': `Conheça a história de ${dataArtistSingle.artistName}, sua discografia e todas as notícias, curiosidades, imagens e letras das músicas.`,
            'og:image': dataArtistSingle.imageNew ? `${A1MEDIA_FACEBOOK}${encodeURI(dataArtistSingle.imageNew)}` : coverImageSrc,
            'og:image:width': 1200,
            'og:image:height': 630,
        },
    };

    return (
        <div className="tw-container tw-m-auto tw-px-4 xl:tw-px-0 singleArtist">
            <HeaderTags title={headerTags.title} meta={headerTags.meta} />

            <article>
                <div className="tw-grid tw-grid-cols-1">
                    <div className="tw-col-span-1">
                        <h1 className="tw-mb-10">
                            {dataArtistSingle.artistName}
                        </h1>
                        <figure>
                            <img src={coverImageSrc} srcSet={coverImageSrcSet} sizes={coverImageSizes} alt="artist single img" width="100%" />
                        </figure>
                    </div>
                </div>

                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 md:tw-gap-10">
                    <div className="tw-col-span-2 lg:tw-col-span-3 tw-mb-5">
                        {/* <InteractiveContainer /> */}
                        {_innerHTMLBiographyArtist()}
                        {/* <Banner key={firstLeaderboardBannerConfig.adUnit} config={firstLeaderboardBannerConfig} /> */}
                    </div>

                    <div className="tw-col-span-2 lg:tw-col-span-1 tw-pt-2">
                        <div className="division">&nbsp;</div>
                        <p className="m-0 tw-py-4">Acesse também</p>
                        <div className="division">&nbsp;</div>

                        <div className="moreArtistMusics tw-my-7">
                            <span>
                                <svg width="34" height="38" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M27.5774 1.111C27.4432 1.00642 27.2869 0.933792 27.1205 0.898608C26.954 0.863424 26.7817 0.866613 26.6167 0.907932L8.69111 5.38933C8.44873 5.44991 8.23356 5.58977 8.07979 5.78667C7.92602 5.98358 7.84248 6.22623 7.84244 6.47606V21.8921C6.90784 21.2676 5.79136 20.9734 4.67038 21.0561C3.54941 21.1389 2.48824 21.5939 1.65547 22.3488C0.822703 23.1038 0.266103 24.1153 0.0741023 25.2228C-0.117898 26.3303 0.0657147 27.4703 0.595768 28.4615C1.12582 29.4527 1.97191 30.2383 2.99962 30.6936C4.02732 31.1488 5.17768 31.2476 6.26795 30.9741C7.35821 30.7007 8.32583 30.0708 9.01708 29.1845C9.70833 28.2981 10.0836 27.2062 10.0831 26.0822V14.0734L25.768 10.1522V17.4107C24.8334 16.7862 23.7169 16.492 22.596 16.5747C21.475 16.6575 20.4138 17.1125 19.581 17.8674C18.7483 18.6224 18.1917 19.6339 17.9997 20.7414C17.8077 21.849 17.9913 22.9889 18.5213 23.9801C19.0514 24.9713 19.8975 25.7569 20.9252 26.2122C21.9529 26.6674 23.1033 26.7662 24.1935 26.4928C25.2838 26.2193 26.2514 25.5894 26.9427 24.7031C27.6339 23.8167 28.0091 22.7248 28.0087 21.6008V1.99467C28.0087 1.82427 27.9699 1.65611 27.8952 1.50298C27.8204 1.34985 27.7117 1.21579 27.5774 1.111ZM5.04157 28.883C4.48761 28.883 3.94609 28.7188 3.48549 28.411C3.02489 28.1032 2.6659 27.6658 2.45391 27.154C2.24192 26.6422 2.18645 26.0791 2.29452 25.5357C2.40259 24.9924 2.66935 24.4934 3.06106 24.1016C3.45277 23.7099 3.95184 23.4432 4.49515 23.3351C5.03847 23.227 5.60163 23.2825 6.11342 23.4945C6.62521 23.7065 7.06265 24.0655 7.37041 24.5261C7.67818 24.9867 7.84244 25.5282 7.84244 26.0822C7.84244 26.825 7.54735 27.5374 7.02209 28.0627C6.49682 28.5879 5.78441 28.883 5.04157 28.883ZM10.0831 11.7627V7.35134L25.768 3.43012V7.84149L10.0831 11.7627ZM22.9671 24.4016C22.4132 24.4016 21.8717 24.2374 21.4111 23.9296C20.9505 23.6218 20.5915 23.1844 20.3795 22.6726C20.1675 22.1608 20.112 21.5977 20.2201 21.0543C20.3282 20.511 20.5949 20.012 20.9866 19.6203C21.3783 19.2285 21.8774 18.9618 22.4207 18.8537C22.964 18.7456 23.5272 18.8011 24.039 19.0131C24.5508 19.2251 24.9882 19.5841 25.296 20.0447C25.6037 20.5053 25.768 21.0468 25.768 21.6008C25.768 22.3436 25.4729 23.056 24.9477 23.5813C24.4224 24.1065 23.71 24.4016 22.9671 24.4016Z" fill="#777C86" />
                                </svg>
                            </span>

                            <div className="tw-ms-7">
                                <p className="text-1">músicas de</p>
                                <p className="text-2">
                                    { dataArtistSingle.artistName }
                                </p>
                                <Link to={`/musicas?letra=false&traducao=false&video=false&busca=${dataArtistSingle.artistName}`} className="listMusicArtist" title={`Acesse também músicas de ${dataArtistSingle.artistName}`}>&nbsp;</Link>
                            </div>
                        </div>

                        <div className="division">&nbsp;</div>

                        {/* <div className="ads tw-py-7">
                            <Banner key={firstRectangleBannerConfig.adUnit} config={firstRectangleBannerConfig} />
                        </div> */}

                        <div className="division">&nbsp;</div>

                        <div className="topMusic tw-mt-7">
                            <div>
                                <p className="text-2">
                                    TOP 3 -
                                    {' '}
                                    {dataArtistSingle.artistName}
                                </p>
                            </div>
                        </div>

                        <ArtistTopSongs />
                    </div>
                </div>
            </article>
        </div>
    );
}

ArtistSingle.propTypes = exact({
    slug: PropTypes.string,
    getSingleArtistIfNeeded: PropTypes.func,
    dataArtistSingle: PropTypes.object.isRequired,
    breakpoint: PropTypes.object.isRequired,
    // isFetching: PropTypes.bool,
    notFound: PropTypes.bool,
    setNotFound: PropTypes.func,
    // news: PropTypes.object,
    // isRelatedNews: PropTypes.bool,
});

export default ArtistSingle;
